import moment from 'moment';
import * as ActionTypes from '../actions/actionTypes';
import {DATA_SETS, TABLE_BACKGROUNDS, TABLE_DIRECTIONS} from '../Constants';

// data_idx is incremented with each new request. Prevents the request overlapping.

const initialState = {
  data_idx: 0,
  graph_progress_count: 0,
  graph_progress_percent: 0,
  graph_progress_seconds: 0,
  graph_progress_start: null,
  graph_progress_total: 1,
  graphs_loaded: false,
  include_history: false,
  short_future: false,
  show_weather: true,
  table_background: TABLE_BACKGROUNDS.COLOR,
  table_directions: TABLE_DIRECTIONS.ARROWS,
  show_all_calc_columns: false,
  data_set: DATA_SETS.WEATHER
};

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case ActionTypes.TOGGLE_GRAPH_SERIES:
      const newGraphs = state.graphs.map((graph) => {
        let new_value = { ...graph };
        if (graph === action.graph) {
          graph.series.map((series) => {
            if (series === action.series) {
              series.active = !series.active;
            }
            return series;
          });
        }
        return new_value;
      });
      return {
        ...state,
        graphs: newGraphs
      };

    case ActionTypes.TOGGLE_GRAPHS_HISTORY:
    case ActionTypes.TOGGLE_TIMELINE_HISTORY:
      return {
        ...state,
        include_history: !state.include_history
      };

    case ActionTypes.TOGGLE_GRAPHS_DAYS:
      return {
        ...state,
        short_future: !state.short_future
      };

    case ActionTypes.SET_TABLE_BACKGROUND:
      return {
        ...state,
        table_background: action.table_background
      };

    case ActionTypes.SET_SHOW_WEATHER:
      return {
        ...state,
        show_weather: action.show_weather
      };

    case ActionTypes.SET_TABLE_DIRECTIONS:
      return {
        ...state,
        table_directions: action.table_directions
      };

    case ActionTypes.TOGGLE_SHOW_ALL_CALC_COLUMNS:
      return {
        ...state,
        show_all_calc_columns: !state.show_all_calc_columns
      };

    case ActionTypes.SELECT_DATA_SET:
      return {
        ...state,
        data_set: action.data.data_set
      };

    case ActionTypes.SET_APP_MODE:
      return {
        ...state,
        data_set: DATA_SETS.WEATHER
      };

    case ActionTypes.CLEAR_GRAPH_DATA:
      return {
        ...initialState,
        graph_progress_total: action.num_points,
        data_idx: action.data_idx,
        include_history: state.include_history,
        short_future: state.short_future,
        table_background: state.table_background,
        table_directions: state.table_directions,
        show_all_calc_columns: state.show_all_calc_columns,
        data_set: state.data_set,
        graph_progress_start: moment()
      };

    case ActionTypes.GRAPH_PROGRESS_TICK:
      const seconds = state.graph_progress_start ?
                      Math.floor(moment.duration(moment().diff(state.graph_progress_start)).asSeconds()) :
                      '';
      return {
        ...state,
        graph_progress_seconds: seconds
      };

    case ActionTypes.POPULATE_INDICATOR_GRAPH_POINT:
      let new_count = state.graph_progress_count;
      if (action.data.features && state.data_idx === action.data_idx) {
        new_count++;
      }

      const new_percent = ((new_count / state.graph_progress_total) * 25).toFixed(0) * 4;
      return {
        ...state,
        graph_progress_count: new_count,
        graph_progress_percent: new_percent
      };

    case ActionTypes.GRAPH_DATA_LOADED:
      if (state.data_idx === action.data_idx) {
        return {
          ...state,
          graphs_loaded: true
        };
      } else {
        return state;
      }

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/graphs.js